import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const CasesField = ({ chapterSelectOptions }) => {
  return (
    <Field name="chapter" parse={values => values.map(({ value }) => value)}>
      {({ input }) => (
        <Fragment>
          <label>Chapter</label>
          <Select {...input} multi options={chapterSelectOptions} className="form-select" />
        </Fragment>
      )}
    </Field>
  );
};

CasesField.propTypes = {
  chapterSelectOptions: PropTypes.array.isRequired,
};

export default CasesField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/ChapterField.jsx